import { customizedProjectsArr } from './helpers';
import {
  APPROVE_TEAM_SUCCESS,
  CREATE_TEAMS_SUCCESS,
  CREATE_TEAM_LOOKUP_SUCCESS,
  CREATE_TEAM_SUCCESS,
  END_TEAM_SUCCESS,
  GET_CATEGORY_USER,
  GET_CATEGORY_USER_ERROR,
  GET_CATEGORY_USER_SUCCESS,
  GET_COMPANY_DETAIL_SUCCESS,
  GET_PROJECT_TEAMS,
  GET_PROJECT_TEAMS_SUCCESS,
  GET_TEAMS,
  GET_TEAMS_SUCCESS,
  REJECT_TEAM_SUCCESS,
  UPDATE_TEAMS,
  UPDATE_TEAMS_NO_APPROVED,
  UPDATE_TEAMS_NO_APPROVED_ERROR,
  UPDATE_TEAMS_NO_APPROVED_SUCCESS,
  UPDATE_TEAMS_SUCCESS,
  UPLOAD_APPLICATION,
  UPLOAD_APPLICATION_ERROR,
  UPLOAD_APPLICATION_SUCCESS,
} from "./actionType"

const initialState = {
  timeSheetReportSuccessList: null,
  timeSheetReportError: null,
  projectListSuccess: null,
  projectListError: null,
  addprofile: null,
  updateprofile: null,
  getTeams: null,
  responseTeam: null,
  responseProjectTeam: null,
  approveTeam: null,
  rejectTeam: null,
  endTeam: null,
  updateteams: null,
  updateteamsError: null,
  updateteamsnoapprove: null,
  updateteamsnoapproveError: null,
  getprojectTeams: null,
  uploadapps: null,
  uploadappsError: null,
  getCategoryUserLists: null,
  getCategoryUserErrorLists: null
}

const createteam = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_TEAM_LOOKUP_SUCCESS:
      state = {
        ...state,
        createTeamLookupList: action.payload,
      }
      break
    case CREATE_TEAM_SUCCESS:
      state = {
        ...state,
        createTeamList: action.payload,
      }
      break

    case GET_TEAMS:
      state = {
        ...state,
        getTeams: action.payload,
      }
      break
    case GET_TEAMS_SUCCESS:
      state = {
        ...state,
        responseTeam: action.payload,
      }
      break

    case APPROVE_TEAM_SUCCESS:
      state = {
        ...state,
        approveTeam: action.payload,
      }
      break
    case REJECT_TEAM_SUCCESS:
      state = {
        ...state,
        rejectTeam: action.payload,
      }
      break
    case END_TEAM_SUCCESS:
      state = {
        ...state,
        endTeam: action.payload,
      }
      break
    //update teeams
    case UPDATE_TEAMS:
      return {
        ...state,
        updateteams: null,
        updateteamsError: null,
      }
      break
    case UPDATE_TEAMS_SUCCESS:
      return {
        ...state,
        updateteams: action.payload,
        updateteamsError: null,
      }
      break
    case GET_COMPANY_DETAIL_SUCCESS:
      return {
        ...state,
        getcompany: action.payload,
      }
      break
    // get tem project base
    case GET_PROJECT_TEAMS:
      state = {
        ...state,
        getprojectTeams: action.payload,
      }
      break
    case GET_PROJECT_TEAMS_SUCCESS:
      const filteredReportArr = customizedProjectsArr(action.payload?.data);
      state = {
        ...state,
        responseProjectTeam: filteredReportArr,
      }
      break
    //not apprval team update
    case UPDATE_TEAMS_NO_APPROVED:
      return {
        ...state,
        updateteamsnoapprove: null,
        updateteamsnoapproveError: null,
      }
      break
    case UPDATE_TEAMS_NO_APPROVED_SUCCESS:
      return {
        ...state,
        updateteamsnoapprove: action.payload,
        updateteamsnoapproveError: null,
      }
      break
    case UPDATE_TEAMS_NO_APPROVED_ERROR:
      return { ...state, updateteamsnoapproveError: action.payload }
      break

    //upload application reducer maintain
    case UPLOAD_APPLICATION:
      return {
        ...state,
        uploadapps: null,
        uploadappsError: null,
      }
      break
    case UPLOAD_APPLICATION_SUCCESS:
      return {
        ...state,
        uploadapps: action.payload,
        uploadappsError: null,
      }
      break
    case UPLOAD_APPLICATION_ERROR:
      return { ...state, uploadappsError: action.payload }
      break

    case GET_CATEGORY_USER:
      return {
        ...state,
        getCategoryUserLists: null,
        getCategoryUserErrorLists: null
      }
      break
    case GET_CATEGORY_USER_SUCCESS:
      return {
        ...state,
        getCategoryUserLists: action?.payload,
        getCategoryUserErrorLists: null
      }
      break
    case GET_CATEGORY_USER_ERROR:
      return {
        ...state,
        getCategoryUserErrorLists: action?.payload
      }
    default:
      state = { ...state }
      break
  }
  return state
}

export default createteam
